import { Link } from "react-router-dom";
import { STEPS } from "../data/content";
import { SectionTitle } from "./Brand";
import { Reveal } from "./Reveal";

const HowItWorks = () => (
    <section id="comment-ca-marche" data-testid="how-section" className="relative py-24 sm:py-32">
        <div className="halo pointer-events-none absolute right-0 top-1/3 h-[24rem] w-[24rem] rounded-full opacity-50" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
            <Reveal>
                <SectionTitle
                    eyebrow="Comment ça marche"
                    title="Quatre étapes, zéro contrainte"
                />
            </Reveal>
            <ol className="relative space-y-10 border-l border-neon/15 pl-8 sm:pl-12">
                {STEPS.map((step, i) => (
                    <Reveal key={step.num} delay={i * 0.12}>
                        <li data-testid={`how-step-${i + 1}`} className="relative">
                            <span className="absolute -left-[3.35rem] top-0 flex h-9 w-9 items-center justify-center rounded-full border border-neon/40 bg-noir font-mono text-xs font-bold text-neon shadow-[0_0_18px_rgba(0,240,255,0.25)] sm:-left-[4.35rem] sm:h-11 sm:w-11 sm:text-sm">
                                {step.num}
                            </span>
                            <h3 className="font-display text-xl font-bold text-white sm:text-2xl">
                                {step.title}
                            </h3>
                            <p className="mt-1.5 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base">
                                {step.desc}
                            </p>
                        </li>
                    </Reveal>
                ))}
            </ol>
            <Reveal delay={0.3}>
                <Link
                    to="/reservation"
                    data-testid="how-reserve-button"
                    className="mt-12 inline-block rounded-full bg-neon px-8 py-4 text-sm font-bold tracking-wide text-noir transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_36px_rgba(0,240,255,0.45)]"
                >
                    RÉSERVER MON CRÉNEAU
                </Link>
            </Reveal>
        </div>
    </section>
);

export default HowItWorks;
